var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_caution",
    d: "M735.492,424.754a12,12,0,1,1-12-12A12,12,0,0,1,735.492,424.754Zm-10.451.729v-7.074a1.522,1.522,0,1,0-3.043,0v7.074a1.522,1.522,0,1,0,3.043,0Zm-.19,6.314a1.939,1.939,0,0,0,.571-1.331,1.784,1.784,0,0,0-.571-1.331,1.934,1.934,0,0,0-1.331-.571,1.78,1.78,0,0,0-1.331.571,1.932,1.932,0,0,0-.571,1.331,1.782,1.782,0,0,0,.571,1.331,1.839,1.839,0,0,0,2.662,0Z",
    transform: "translate(-711.492 -412.754)",
    fill: "#4c125a"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.361cc874.svg";
export { ForwardRef as ReactComponent };